import {
	SEARCH_FETCH,
	SEARCH_SUCCESS,
	SEARCH_FAILURE,
	RESET_SEARCH
} from '../actions/SearchResultActions';

import {
	FORUM_FOLLOWING,
	THREAD_FOLLOWING
} from '../actions/ForumviewActions';

import { LOADING_BEHAVIOR } from '../actions/InfiniteScrollActions';

import merge from 'lodash/merge';
import union from 'lodash/union';

const initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		forums: [],
		posts: [],
		topics: [],
		users: []
	},
	searchId: 0,
	commonwords:[],
	query: {
		searchQuery: '',
		showposts: 0,
		showtopics: 1,
		forumId: '',
		action: ''
	},
	page: 1
};

export default function searchresult(prevState = initialState, action) {
	switch (action.type) {
		case SEARCH_FETCH:
			return Object.assign({},
				prevState,
				{
					isFetching: true,
					// Only set loaded to false if we are doing a full refresh
					loaded: !( action.query.loadingBehavior === LOADING_BEHAVIOR.REFRESH )
				});

		case SEARCH_SUCCESS:
			if (
				prevState.query.searchQuery !== action.data.query.searchQuery
				|| prevState.query.showposts != action.data.query.showposts
				|| prevState.query.showtopics != action.data.query.showtopics
				|| action.query.loadingBehavior === LOADING_BEHAVIOR.REFRESH
			) {
				return merge(
					{},
					action.data,
					{
						isFetching: false,
						loaded: true,
						query: action.data.query,
						pages: [parseInt( action.data.page )]
					}
				);

			} else {
				let postsResult, topicsResult, forumsResult, usersResult, pages;

				if(action.query.loadingBehavior === LOADING_BEHAVIOR.PREPEND) {
					postsResult = [...action.data.result.posts, ...prevState.result.posts];
					topicsResult = [...action.data.result.topics, ...prevState.result.topics];
					forumsResult = [...action.data.result.forums, ...prevState.result.forums];
					usersResult = union(action.data.result.users, prevState.result.users);
					pages = [parseInt( action.data.page ),...prevState.pages];
				} else if(action.query.loadingBehavior === LOADING_BEHAVIOR.APPEND) {
					postsResult = [...prevState.result.posts, ...action.data.result.posts];
					topicsResult = [...prevState.result.topics, ...action.data.result.topics];
					forumsResult = [...prevState.result.forums, ...action.data.result.forums];
					usersResult = union(prevState.result.users, action.data.result.users);
					pages = [...prevState.pages, parseInt( action.data.page )];
				}

				return merge(
					{},
					prevState,
					action.data,
					{
						isFetching: false,
						loaded: true,
						query: action.query
					},
					{
						pages: pages,
						result: {
							posts: postsResult,
							topics: topicsResult,
							forums: forumsResult,
							users: usersResult
						}
					}
				);
			}

		case RESET_SEARCH:
			return initialState;

		case SEARCH_FAILURE:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case FORUM_FOLLOWING:
			if( prevState.entities.forums ) {
				let prevEntitiesForum = prevState.entities.forums,
					forum = prevState.entities.forums[ action.forumId ];

				forum.isSubscribed = action.follow;
				let entitiesForum = {
					forums: Object.assign( {}, prevEntitiesForum, { [ action.forumId ]: forum } )
				};
				return Object.assign( {}, prevState, entitiesForum );
			}
			return prevState;

		case THREAD_FOLLOWING:
			let prevEntitiesThread = {}, thread = {}, entities = '';
			if( prevState.entities.topics && prevState.entities.topics[ action.threadId ] ) {
				entities = 'topics';
			} else if( prevState.entities.sticky && prevState.entities.sticky[ action.threadId ] ) {
				entities = 'sticky';
			} else {
				return prevState;
			}

			prevEntitiesThread = prevState.entities[ entities ];
			thread = prevState.entities[ entities ][ action.threadId ];

			thread.isSubscribed = action.follow;
			let entitiesThreads = {
				[ entities ]: Object.assign( {}, prevEntitiesThread, { [ action.threadId ]: thread } )
			};
			return Object.assign( {}, prevState, entitiesThreads );

		default :
			return prevState;
	}

}




// WEBPACK FOOTER //
// ./common/reducers/searchresult.js